import { getMainDomain, getTopLevelDomain } from "./DomainUtils.js";
function getSSOBannerConfig({ country, type }) {
  if (country === "nl") {
    if (type === "magazine") return "NL-Magazines";
    if (type === "paper") return "NL-Newspaper";
  }
  if (country === "be") {
    if (type === "paper") return "BE-Newspaper";
    return "BE-TV/Radio";
  }
  return "NL-Newspaper";
}
export function initSso(params) {
  if (!window.ssoDetection) return;
  params = {
    loggedInEmail: "",
    callBacks: {},
    ...params
  };
  const { country, type, loggedInEmail, callBacks, brandCode } = params;
  const mainDomain = getMainDomain(window.location.host);
  const topLevelDomain = getTopLevelDomain(window.location.host);
  if (!["nl", "be"].includes(topLevelDomain)) return;
  const bannerConfig = getSSOBannerConfig({ country, type });
  const ssoConfig = {
    loggedInEmail,
    authorizeUrl: () => `https://account.${mainDomain}/login?callback_url=${encodeURIComponent(window.location.href)}`,
    topLevelDomain,
    bannerConfig,
    logoUrl: `https://cdn-03.tapp.dpgmedia.cloud/touchpoints/EM_DM/logos-new/header/default/${brandCode.toUpperCase()}_2x.png`,
    ...callBacks
  };
  window.ssoDetection.trigger(ssoConfig);
}
